module.exports = __webpack_public_path__ + "static/media/24UHCHR17.d1ca0d1b.jpg";